import React from 'react';

export default class InlineErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error('[inline-error-boundary] uncaught', error, errorInfo);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    if (this.props.fallback) return this.props.fallback;

    const errorMessage = this.state.error?.message || String(this.state.error || 'Unknown render error');
    const componentStack = this.state.errorInfo?.componentStack || '';

    return (
      <div className="m-4 rounded-2xl border border-red-500/30 bg-red-900/10 p-4 text-slate-100">
        <div className="text-lg font-bold text-red-200">Something broke</div>
        <div className="mt-1 text-sm text-slate-200">Screenshot this and send to Blake</div>
        <button
          onClick={() => window.location.reload()}
          className="mt-3 inline-flex rounded-lg bg-red-700 hover:bg-red-600 px-3 py-2 text-sm font-semibold text-white"
        >
          Reload app
        </button>
        <details className="mt-3 rounded-lg border border-slate-700 bg-slate-900/60 p-3">
          <summary className="cursor-pointer text-xs font-semibold text-slate-300">Error details</summary>
          <pre className="mt-2 whitespace-pre-wrap break-words text-[11px] text-slate-300">{errorMessage}</pre>
          {componentStack ? (
            <pre className="mt-2 whitespace-pre-wrap break-words text-[11px] text-slate-400">{componentStack}</pre>
          ) : null}
        </details>
      </div>
    );
  }
}
